import React, { useEffect } from 'react'
import workWechatConfig from 'utils/work-wechat-config'
import { loginRedirectUrl } from 'utils'
import qs from 'query-string'
import './index.less'

// 企业微信登录
export default function WorkWeChatQR() {
  useEffect(() => {
    let search =
      window.sessionStorage.getItem('search') || `?url=${loginRedirectUrl()}`

    let searchObj = qs.parse(search)
    !searchObj?.applicationCode &&
      (search += `&applicationCode=${searchObj?.applicationCode || 'passport'}`)

    const state = JSON.stringify({
      back_url: window.location.href,
      type: 'redirect',
    })
    window.WwLogin({
      id: 'wechat-qrcode',
      appid: workWechatConfig.appid,
      agentid: workWechatConfig.agentid,
      redirect_uri: encodeURIComponent(workWechatConfig.redirect_uri + search),
      state: encodeURIComponent(encodeURIComponent(state)),
      /**
       * 使用base64编码注入以下样式
        .impowerBox .qrcode {width: 180px;}
        .impowerBox  .wrp_code {margin-top:0 !important;}
        .impowerBox .title {display: none;}
        .status_icon {display: none}
        .impowerBox .status {text-align: center;}
      */
      href: 'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDEycmVtO30NCi5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0NCi5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9',
    })
  }, [])

  return <div id="wechat-qrcode"></div>
}
